module.exports = __webpack_public_path__ + "static/img/jiulei.f3c3fd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jiulei.png
// module id = T2WG
// module chunks = 0